<template>
  <div class="medical_cases">
    <Navbar />
    <v-container>
      <v-layout row wrap>
        <v-dialog v-model="dialog" max-width="700px">
          <v-btn slot="activator" color="primary" dark class="mb-2">New Medical Case</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-form v-model="validForm" lazy-validation>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field v-model="editedMC.name" label="Name of Medical Case" required :rules="nameRules"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-checkbox v-model="editedMC.surgical" label="Surgical"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-checkbox v-model="editedMC.hospitalisation" label="Need for Hospitalisation"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-checkbox v-model="editedMC.usar" label="USAR"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-checkbox v-model="editedMC.medivac" label="MEDIVAC"></v-checkbox>
                    </v-flex>
                    <v-flex xs 12>
                      <v-subheader class="pl-0 title">Triage</v-subheader>
                      <v-slider v-model="editedMC.triage" :tick-labels="triageLevels" :max="4" step="1" ticks="always"
                        tick-size="1"></v-slider>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedMC.short_summary" label="Short Summary" rows="1" auto-grow></v-textarea>
                    </v-flex>
                    <v-flex>
                      <v-expansion-panel>
                        <v-expansion-panel-content>
                          <div slot="header">Medical History</div>
                          <v-flex xs12>
                            <v-text-field v-model="editedMC.history.problems" label="Problems/Conditions"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedMC.history.vaccinations" label="Vaccinations"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedMC.history.allergies" label="Allergies"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedMC.history.medication" label="Medication"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field v-model="editedMC.history.implantable_devices" label="Implantable Devices"></v-text-field>
                          </v-flex>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model="editedMC.nationality" label="Nationality"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select :items="ageSpans" v-model="editedMC.age_span" label="Age" required :rules="selectRules"></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-select :items="genders" v-model="editedMC.gender" label="Gender" required :rules="selectRules"></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedMC.general_condition" label="General Condition" rows="1" auto-grow></v-textarea>
                    </v-flex>
                    <v-expansion-panel>
                      <v-expansion-panel-content>
                        <div slot="header">Vital signs</div>
                        <v-flex xs12>
                          <v-text-field v-model="editedMC.vital_signs.onset_of_symptoms" label="Onset of Symptoms"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model="editedMC.vital_signs.AVPU" label="AVPU"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model="editedMC.vital_signs.mobility" label="Mobility"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.number="editedMC.vital_signs.respiratory_rate" label="Respiratory Rate"
                            type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.number="editedMC.vital_signs.pulse_rate" label="Pulse Rate" type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.number="editedMC.vital_signs.temperatur" label="Temperatur" type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.number="editedMC.vital_signs.capillary_refill" label="Capillary Refill"
                            type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model="editedMC.vital_signs.blood_presure" label="Blood Pressure"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.number="editedMC.vital_signs.oxygen_saturation" label="Oxygen Saturation"
                            type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.number="editedMC.vital_signs.weight" label="Weight" type="number"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.number="editedMC.vital_signs.height" label="Height" type="number"></v-text-field>
                        </v-flex>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-flex xs12>
                      <v-textarea v-model="editedMC.general_status" label="General Status" rows="1" auto-grow></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedMC.on_examination" label="On Examination" rows="1" auto-grow></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedMC.expectations" label="Expectations and Outcomes" rows="1" auto-grow></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedMC.makeup" label="Needed Make-Up and Attributes" rows="1" auto-grow></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedMC.others" label="Other Information" rows="1" auto-grow></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <p>Documents ({{bytesToSize(documentsByte)}}/{{bytesToSize(maxByteSize)}})</p>
                      <input type="file" ref="myFiles" multiple @change="onFileChange">
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
                <v-btn :disabled="!validForm" color="blue darken-1" flat @click.native="save">Save</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-layout>
      <v-data-table :items="medicalCases" :headers="headers" class="elevation-1" :search="search" :custom-filter="filterItems"
        :rows-per-page-items='[10,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'>
        <template slot="items" slot-scope="props">
          <td @click="openMedicalCase(props.item)">{{ props.item.name }}</td>
          <td @click="openMedicalCase(props.item)">{{ props.item.gender }}</td>
          <td @click="openMedicalCase(props.item)">{{ props.item.age_span }}</td>
          <td @click="openMedicalCase(props.item)">
            <v-icon small v-if="props.item.surgical">done</v-icon>
            <v-icon small v-if="!props.item.surgical">clear</v-icon>
          </td>
          <td @click="openMedicalCase(props.item)">
            <v-icon small v-if="props.item.usar">done</v-icon>
            <v-icon small v-if="!props.item.usar">clear</v-icon>
          </td>
          <td @click="openMedicalCase(props.item)">
            <v-icon small v-if="props.item.medivac">done</v-icon>
            <v-icon small v-if="!props.item.medivac">clear</v-icon>
          </td>
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editMedicalCase(props.item)">
              edit
            </v-icon>
            <v-icon small @click="deleteMedicalCase(props.item)">
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-container>

    <v-snackbar v-model="newMCCantCreate" :right="true">
      Medical case can't be created.
      <v-btn color="pink" flat @click="newMCCantCreate = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Navbar from '@/components/Navbar.vue'
  import axios from 'axios';
  axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

  export default {
    name: 'medical_cases',
    data() {
      return {
        createdMC: {},
        search: '',
        medicalCases: [],
        documents: [],
        documentsByte: 0,
        maxByteSize: 10000000,
        dialog: false,
        newMCCantCreate: false,
        editedIndex: -1,
        triageLevels: ["Non Urgent", "Less Urgent", "Urgent", "Emergent", "Resuscitation"],
        ageSpans: ['all', '0-5', '5-12', '13-17', '18-30', '31-60', '60+'],
        genders: ['all', 'm', 'f'],
        headers: [{
            text: 'Name of Medical Case',
            align: 'left',
            value: 'name'
          },
          {
            text: 'Gender',
            value: 'gender'
          },
          {
            text: 'Agespan',
            value: 'age_span'
          },
          {
            text: 'Surgical',
            value: 'surgical'
          },
          {
            text: 'USAR',
            value: 'usar'
          },
          {
            text: 'MEDIVAC',
            value: 'medivac'
          },
        ],
        editedMC: {
          id: '',
          name: '',
          surgical: false,
          hospitalisation: false,
          usar: false,
          medivac: false,
          triage: 0,
          short_summary: '',
          history: {
            problems: '',
            vaccinations: '',
            allergies: '',
            medication: '',
            implantable_devices: ''
          },
          age_span: 'all',
          gender: 'all',
          nationality: '',
          general_condition: '',
          vital_signs: {
            onset_of_symptoms: '',
            AVPU: '',
            mobility: '',
            respiratory_rate: null,
            pulse_rate: null,
            temperatur: null,
            capillary_refill: null,
            blood_presure: null,
            oxygen_saturation: null,
            weight: null,
            height: null
          },
          general_status: '',
          on_examination: '',
          expectations: '',
          makeup: '',
          others: '',
          documents: []
        },
        defaultMedicalCase: {
          id: '',
          name: '',
          surgical: false,
          hospitalisation: false,
          usar: false,
          medivac: false,
          triage: 0,
          short_summary: '',
          history: {
            problems: '',
            vaccinations: '',
            allergies: '',
            medication: '',
            implantable_devices: ''
          },
          age_span: 'all',
          gender: 'all',
          nationality: '',
          general_condition: '',
          vital_signs: {
            onset_of_symptoms: '',
            AVPU: '',
            mobility: '',
            respiratory_rate: null,
            pulse_rate: null,
            temperatur: null,
            capillary_refill: null,
            blood_presure: null,
            oxygen_saturation: null,
            weight: null,
            height: null
          },
          general_status: '',
          on_examination: '',
          expectations: '',
          makeup: '',
          others: '',
          documents: []
        },
        validForm: false,
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 50) || 'Name must be less than 50 characters'
        ],
        selectRules: [
          v => !!v || 'Please select a value'
        ]
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Medical Case' : 'Edit Medical Case'
      }
    },
    components: {
      Navbar
    },
    methods: {
      filterItems(items, search, filter) {
        if (!search) {
          return items
        }
        //Split search in array
        let needleAry = search.toString().toLowerCase().split(" ").filter(x => x.trim().length > 0);
        //to make it accessable in subfuntions
        var self = this

        function myFilter(item, search) {
          return filterName(item, search) || filterGender(item, search) || filterOthers(item, search) ||
            filterAge(item, search) || filterSurgical(item, search) || filterHospital(item, search) ||
            filterNationality(item, search) || filterUSAR(item, search) || filterMedivac(item, search)
        }

        function filterName(item, search) {
          return item.name != null &&
            item.name.toLowerCase().includes(search)
        }

        function filterGender(item, search) {
          if ('male'.includes(search)) {
            return item.gender == 'm'
          } else if ('female'.includes(search)) {
            return item.gender == 'f'
          } else if ('all'.includes(search)) {
            return item.gender == 'all'
          }
          return false
        }

        function filterOthers(item, search) {
          return item.others != null &&
            item.others.toLowerCase().includes(search)
        }

        function filterNationality(item, search) {
          return item.nationality != null &&
            item.nationality.toLowerCase().includes(search)
        }

        function filterAge(item, search) {
          if (item.age_span == null) {
            return false
          }
          var lengthAgeSpans = self.ageSpans.length
          for (var i = 0; i < lengthAgeSpans; i++) {
            var arr = self.ageSpans[i].split("-")
            if (arr.length > 1) {
              var min = arr[0]
              var max = arr[1]
              if (parseInt(search) >= parseInt(min) && parseInt(search) <= parseInt(max)) {
                return item.age_span == self.ageSpans[i]
              }
            } else if (arr[0] == "all" && "all".includes(search)) {
              return item.age_span == "all"
            } else if (arr[0] == "60+" && parseInt(search) >= 60) {
              return item.age_span == "60+"
            }
          }
          return false
        }

        function filterSurgical(item, search) {
          if ('surgical'.includes(search)) {
            return item.surgical
          }
          return false
        }

        function filterHospital(item, search) {
          if ('hospitalisation'.includes(search)) {
            return item.hospitalisation
          }
          return false
        }
        function filterUSAR(item, search) {
          if ('usar'.includes(search)) {
            return item.usar
          }
          return false
        }
        function filterMedivac(item, search) {
          if ('medivac'.includes(search)) {
            return item.medivac
          }
          return false
        }

        return items.filter(row => needleAry.every(needle => myFilter(row, needle)))
      },
      fetchMedicalCases() {
        axios.get('medical_cases_short').then(response => {
          this.medicalCases = response.data.reverse()
        }).catch(error => {})
      },
      editMedicalCase(medicalCase) {
        this.editedIndex = this.medicalCases.indexOf(medicalCase)
        axios.get('/medical_cases/' + medicalCase.id).then(response => {
          this.editedMC = Object.assign({}, response.data)
          var lengthDocuments = this.editedMC.documents.length;
          for (var i = 0; i < lengthDocuments; i++) {
            this.documentsByte += this.editedMC.documents[i].bytes;
          }
        }).catch(error => {})
        this.dialog = true
        this.onFileChange();
      },
      close() {
        this.dialog = false
        setTimeout(() => {
          this.editedMC = Object.assign({}, this.defaultMedicalCase)
          this.editedIndex = -1
          this.validForm = false
          this.documents = []
          this.documentsByte = 0
          const input = this.$refs.myFiles
          input.type = 'text'
          input.type = 'file'
        }, 300)
      },
      save() {
        if (this.editedMC.id === '') {
          this.createMedicalCase(this.editedMC);
        } else {
          this.updateMedicalCase(this.editedMC);
        }
        this.close()
      },
      createMedicalCase(medicalCase) {

        axios.post('medical_cases', medicalCase).then(response => {

          this.createdMC = response.data
          var lengthDocuments = this.documents.length
          for (var i = 0; i < lengthDocuments; i++) {
            var formdata = new FormData()
            formdata.append('file', this.documents[i])
            axios.post('medical_cases/' + this.createdMC.id + '/documents', formdata).then(response => {
              this.createdMC.documents.push(response.data)
            }).catch(error => {})
          }

          this.medicalCases.unshift(this.createdMC)
        }).catch(error => {
          this.newMCCantCreate = true
        });


      },
      updateMedicalCase(medicalCase) {
        var mc = this.editedMC
        axios.put('/medical_cases', medicalCase).then(response => {
          var lengthDocuments = this.documents.length
          for (var i = 0; i < lengthDocuments; i++) {
            var formdata = new FormData()
            formdata.append('file', this.documents[i])
            axios.post('medical_cases/' + mc.id + '/documents', formdata).then(response => {
              mc.documents.push(response.data)
            }).catch(error => {})
          }

        }).catch(error => {});

        Object.assign(this.medicalCases[this.editedIndex], mc)
      },
      deleteMedicalCase(medicalCase) {
        if (confirm('Are you sure you want to delete this medical case?')) {
          axios.delete('/medical_cases', {
            data: Object.assign({}, medicalCase)
          }).then(response => {
            this.medicalCases.splice(this.medicalCases.indexOf(medicalCase), 1);
          }).catch(error => {})
        }

      },
      openMedicalCase(medicalCase) {
        this.$router.push({
          name: 'medical_case',
          params: {
            id: medicalCase.id
          }
        })
      },
      onFileChange() {
        this.documents = this.$refs.myFiles.files
        var size = 0
        var lengthDocuments = this.documents.length
        for (var i = 0; i < lengthDocuments; i++) {
          size += this.documents[i].size
        }
        var lengthNewDocuments = this.editedMC.documents.length
        for (var i = 0; i < lengthNewDocuments; i++) {
          size += this.editedMC.documents[i].bytes
        }
        this.documentsByte = size
        if (this.documentsByte > this.maxByteSize) {
          this.validForm = false
        }
      },
      bytesToSize(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 MB';
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        if (i === 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
      },
    },
    mounted() {
      this.fetchMedicalCases();
    }
  }
</script>